module.exports = __webpack_public_path__ + "img/heart-3.d907041e.svg";